import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {GetUrlVariable} from './../../utils/constants';
import Chapter1 from './chapter1';
import Chapter2 from './chapter2';
import Chapter3 from './chapter3';
import Chapter4 from './chapter4';
import Chapter5 from './chapter5';
import Chapter6 from './chapter6';
import Chapter7 from './chapter7';
import Chapter8 from './chapter8';
import Chapter9 from './chapter9';
import Chapter10 from './chapter10';
import Chapter11 from './chapter11';
import Chapter12 from './chapter12';
import Chapter13 from './chapter13';
import Chapter14 from './chapter14';
import Chapter15 from './chapter15';
import {Helmet} from "react-helmet";
import "./toolkits.css";
export default class Toolkits extends Component {
  componentDidMount = () =>{
    let headerContainerList = document.getElementsByClassName('header-container');
    headerContainerList[0].style.display = 'none';
  }
  render() {
    let contents = null;
    let id = GetUrlVariable("id");
    if(id == "chapter1"){
      contents = <Chapter1 />
    }
    if(id == "chapter2"){
      contents = <Chapter2 />
    }
    if(id == "chapter3"){
      contents = <Chapter3 />
    }
    if(id == "chapter4"){
      contents = <Chapter4 />
    }
    if(id == "chapter5"){
      contents = <Chapter5 />
    }
    if(id == "chapter6"){
      contents = <Chapter6 />
    }
    if(id == "chapter7"){
      contents = <Chapter7 />
    }
    if(id == "chapter8"){
      contents = <Chapter8 />
    }
    if(id == "chapter9"){
      contents = <Chapter9 />
    }
    if(id == "chapter10"){
      contents = <Chapter10 />
    }
    if(id == "chapter11"){
      contents = <Chapter11 />
    }
    if(id == "chapter12"){
      contents = <Chapter12 />
    }
    if(id == "chapter13"){
      contents = <Chapter13 />
    }
    if(id == "chapter14"){
      contents = <Chapter14 />
    }
    if(id == "chapter15"){
      contents = <Chapter15 />
    }
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina | Author of the book, The Joys of Jet Lag'}</title>
          <meta name="description" content="World traveler. Writer. Entrepreneur. Joy finder. Kat Medina, author of the book, The Joys of Jet Lag." />
        </Helmet>
        <div>
          {contents}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/index.js